<template>
  <div id="app" class="">
    <HeaderDefault v-bind:class="{'webview-avaliable': hideHeader}"></HeaderDefault>
    <div  class="app-content container-xl app-container app">
      <div v-bind:class="{'hidde-all': !loadingStatus}">
        <Loading></Loading>
      </div>
      <div v-bind:class="{'hidde-all': loadingStatus}" class="conteudo-app">
        <router-view/>
      </div>
    </div>
  </div>
</template>


<script>
import HeaderDefault from './components/shared/HeaderDefault';
import Loading from "./components/shared/Loading";
import WebViewBridgeService from "./services/WebViewBridgeService";
export default {
  name: 'App',
  components: {Loading, HeaderDefault},
  mounted() {
    let webviewService = new WebViewBridgeService();
    webviewService.setActionBehavior(
        'Quer sair da biometria?',
        'Você ainda não terminou de confirmar sua identidade e suas informações ainda não estão salvas',
        'sair',
        'voltar');
  },
  computed:{
    loadingStatus() {
      return this.$store.getters.loadingStatus
    },
    hideHeader(){
      return  (this.$route.name !== 'TermoUso');
    }
  }
}
</script>

<style>
.hidde-all{
  display: none;
}
.webview-avaliable .container-header .app-container{
  display: none !important;
}
.webview-avaliable .container-header{
  background-color: transparent !important;
  color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue